<template>
  <vendor-list :memberFlag="0" />
</template>
<script>
import VendorList from './busi/vendor-list.vue'

export default {
  name: 'VendorListIndex',
  components: { VendorList },
  data() {
    return { query: { memberFlag: 0 }}
  }
}
</script>
